import React from "react";
import { formatDateTimeInTimezone } from "../../utils/dateTimeUtils";

const OrderStatusHistory = ({ statusHistory, timezone }) => (
  <div style={{ marginTop: "30px" }}>
    <h3>Order Status History</h3>
    <table style={{ width: "100%", borderCollapse: "collapse", backgroundColor: "white" }}>
      <thead>
        <tr>
          <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: "left" }}>Status</th>
          <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: "left" }}>Updated At</th>
          <th style={{ padding: "8px", border: "1px solid #ddd", textAlign: "left" }}>Time Taken</th>
        </tr>
      </thead>
      <tbody>
        {statusHistory.length > 0 ? (
          statusHistory.map((history, index, arr) => {
            let timeSpent = "--";
            if (index > 0) {
              const current = new Date(history.createdAt);
              const previous = new Date(arr[index - 1].createdAt);
              const diffMs = current - previous;
              const totalSeconds = Math.floor(diffMs / 1000);
              const hours = Math.floor(totalSeconds / 3600);
              const minutes = Math.floor((totalSeconds % 3600) / 60);
              const seconds = totalSeconds % 60;
              timeSpent = `${hours}h ${minutes}m ${seconds}s`;
            }
            const formattedUpdatedAt = formatDateTimeInTimezone(
              history.updatedAt || history.createdAt,
              timezone,
            );
            return (
              <tr key={history._id}>
                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                  {history.status.charAt(0).toUpperCase() + history.status.slice(1)}
                </td>
                <td style={{ padding: "8px", border: "1px solid #ddd" }}>{formattedUpdatedAt}</td>
                <td style={{ padding: "8px", border: "1px solid #ddd" }}>{timeSpent}</td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan="3" style={{ padding: "8px", textAlign: "center" }}>
              No status history available
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);


export default OrderStatusHistory;
